import { ChangeDetectorRef, inject, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { copy } from '../lib/copy';
import { objectsMatch } from '../lib/objects-match';
import { LanguageService } from '../services/language.service';
import { TranslateService } from '../services/translate.service';

@Pipe({
  name: 'translate',
  pure: false,
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private translateService = inject(TranslateService);
  private languageService = inject(LanguageService);
  private cdr = inject(ChangeDetectorRef);

  private subscription: Subscription | null = null;
  private lastKey: string | null = null;
  private lastParams: { [key: string]: string | number };
  private lastValue: string | null = null;
  private lastLanguage: string | null = null;

  transform(defaultText: string, key: string, params?: { [key: string]: string | number }): string {
    if (
      key === this.lastKey &&
      objectsMatch(params, this.lastParams) &&
      this.languageService.currentLanguage() === this.lastLanguage
    ) {
      // same input → return cached value
      return this.lastValue || defaultText.replace(/./g, ' ');
    }

    this.lastKey = key;
    this.lastParams = params;
    this.lastLanguage = this.languageService.currentLanguage();

    // cancel previous subscription
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }

    // subscribe to new observable
    this.subscription = this.translateService.translate({ ___: key, defaultText }, params).subscribe(value => {
      this.lastValue = copy(value);
      this.cdr.markForCheck(); // tell Angular to re-render
    });

    return this.lastValue || defaultText.replace(/./g, ' ');
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
